/**
 * @function createButton
 * @description Creates SRC Mark HTML button.
 * @param {Document} document The DOM object.
 * @returns {HTML} Button tag.
 */
export const createButton = (document) => {
  const buttonElement = document.createElement('button')
  buttonElement.setAttribute('style', 'border: none')
  return buttonElement
}
